import React, { Fragment } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const InvoiceCreateErrorsModal = ({
  visible = false,
  onClose = () => {},
  errors,
}) => {
  if (!errors) {
    return <Fragment></Fragment>
  }

  const groupedErrors = _.groupBy(errors, x => x.property);

  return (
    <Modal style={{ maxWidth: "650px" }} isOpen={visible}>
      <ModalHeader
        close={
          <span className="bold hand" onClick={onClose}>
            X
          </span>
        }
      >
        Client Locations With Invalid Fields
      </ModalHeader>
      <ModalBody>
        <p>
          Please update the following locations before submitting the request.
          Alternatively, you can uncheck them and continue.
        </p>
        <ul>
        {Object.keys(groupedErrors).map(key => (
          <Fragment>
            <li>
              <h6>{key}</h6>
              <ul>
                {groupedErrors[key].map(err => (
                  <li><span>{err.message}</span></li>
                ))}
              </ul>
            </li>  
          </Fragment>
        ))} 
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default InvoiceCreateErrorsModal;
